import { useState } from 'react'
import styled from 'styled-components'
import { InformationCircle } from '@styled-icons/ionicons-outline/InformationCircle'

type HintLabelProps = {
  hint: string
  hintInfo?: string
  fontSize: string
  fontWeight?: string
  size: string
  isLeftIcon?: boolean
  isDimmed?: boolean
  rightAligned?: boolean
  minWidth?: string
}

const HintLabel = ({
  hint,
  hintInfo,
  fontSize,
  fontWeight = '400',
  size,
  isLeftIcon = false,
  isDimmed = false,
  rightAligned,
  minWidth,
}: HintLabelProps): JSX.Element => {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <InfoContainer>
      <Row
        isLeftIcon={isLeftIcon}
        isDimmed={isDimmed}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <TextLabel fontSize={fontSize} fontWeight={fontWeight}>
          {hint}
        </TextLabel>
        <InfoIcon size={size} isLeftIcon={isLeftIcon} />
      </Row>
      <InfoTooltip visible={isHovered} rightAligned={rightAligned} minWidth={minWidth}>
        <InfoTooltipText>{hintInfo}</InfoTooltipText>
      </InfoTooltip>
    </InfoContainer>
  )
}

export default HintLabel

const Row = styled.div<{ isLeftIcon: boolean; isDimmed: boolean }>`
  display: flex;
  flex-direction: ${(props) => (props.isLeftIcon ? 'row-reverse' : 'row')};
  align-items: center;
  cursor: default;
  color: ${(props) => (props.isDimmed ? 'rgba(255, 255, 255, 0.8)' : 'white')};
  gap: 5px;

  @media (max-width: 43em) {
    justify-content: center;
  }
`

const TextLabel = styled.div<{ fontSize: string; fontWeight: string }>`
  font-size: ${(props) => props.fontSize};
  font-weight: ${(props) => props.fontWeight};
`

const InfoContainer = styled.div`
  position: relative;
`

const InfoIcon = styled(InformationCircle)<{ isLeftIcon: boolean }>`
  width: ${(props) => (props.isLeftIcon ? '20px' : '40px')};
`

const InfoTooltip = styled.div<{ visible: boolean; rightAligned?: boolean; minWidth?: string }>`
  visibility: ${(props) => (props.visible ? 'visible' : 'hidden')};

  position: absolute;
  background: #323232;
  border-radius: 6px;
  padding: 5px;
  top: 40px;
  min-width: ${(props) => props.minWidth ?? `350px`};
  z-index: 100000;

  ${(props) =>
    props.rightAligned ? `right: 0px;` : `left: 0px;`}/* transform: translateX(-10%); */
`

const InfoTooltipText = styled.div`
  text-align: left;
  font-size: 14px;
  font-weight: 500;
  color: white;
  white-space: pre-wrap;
`
